import { IBook } from '@partiu/api/types';
import { createContext, PropsWithChildren, useContext, useState } from 'react';

interface IOpenBookContext {
  isReceivedBook: boolean;
  book: IBook | undefined;
  openBook: (book: IBook, receivedBook?: boolean) => void;
  closeBook: () => void;
}

const defaultOpenBookContext: IOpenBookContext = {
  book: undefined,
  isReceivedBook: false,
  openBook: () => {},
  closeBook: () => {},
};

const OpenBookContext = createContext(defaultOpenBookContext);

export function OpenBookProvider({ children }: PropsWithChildren) {
  const [data, setData] = useState(defaultOpenBookContext);
  const [isReceivedBook, setIsReceivedBook] = useState(false);
  return (
    <OpenBookContext.Provider
      value={{
        ...data,
        isReceivedBook,
        openBook: (book: IBook, receivedBook?: boolean) => {
          setData({ ...data, book });
          setIsReceivedBook(!!receivedBook);
        },
        closeBook: () => setData({ ...data, book: undefined }),
      }}
    >
      {children}
    </OpenBookContext.Provider>
  );
}

export function useOpenBook() {
  return useContext(OpenBookContext);
}
